import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { EBOOK, openEbook } from "@/lib/ebook";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative z-10 border-t border-white/5 py-28 md:py-40 overflow-hidden bg-[#080808]">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_100%,rgba(130,73,55,0.35),transparent_60%)]" aria-hidden />
      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <p className="overline">The Invitation</p>
        <h2 className="font-serif-display text-[36px] sm:text-5xl lg:text-[80px] leading-[0.98] mt-5 tracking-tight">
          Your story already happened.<br />
          Now give it the <span className="italic text-[#D4AF37]">presentation it deserves.</span>
        </h2>
        <p className="text-white/65 mt-8 font-light leading-relaxed max-w-2xl mx-auto text-base md:text-lg">
          Whether you&apos;re celebrating where you&apos;ve been, who you love, what you&apos;ve accomplished or where you&apos;re headed next, Crowned Canvas Creations can help turn the story into something you can see every day.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-10">
          <Link
            to="/#experiences"
            data-testid="final-cta-create"
            className="group inline-flex items-center gap-3 bg-[#D4AF37] text-[#080808] px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
          >
            Create Your Masterpiece
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
          <button
            type="button"
            onClick={() => openEbook("final-cta")}
            data-testid="final-cta-guide"
            className="group inline-flex items-center gap-3 border border-[#824937] bg-[#824937]/20 text-[#F7F1E7] px-7 py-4 text-xs uppercase tracking-[0.22em] hover:bg-[#824937]/40 transition-all"
          >
            <BookOpen className="w-4 h-4" />
            Start With The Free Guide
          </button>
        </div>
      </div>
    </section>
  );
}
